"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M1 19h22V5H1zM19 7v10H5V7z"
}), 'StayPrimaryLandscapeSharp');